module.exports = __webpack_public_path__ + "static/pid-ug-28-en-signed-20bda38ec67a8a503b94eb9206dadb70.png";